import { render, staticRenderFns } from "./InsurerModal.vue?vue&type=template&id=d2384e80&scoped=true"
import script from "./InsurerModal.vue?vue&type=script&lang=js"
export * from "./InsurerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2384e80",
  null
  
)

export default component.exports